import React, { Fragment, useState } from "react";

import ajaxMethods from "../../../api/ajax-methods";
import ajaxApi from "../../../api/axios-register";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { MDBDataTable } from "mdbreact";
import {
  reOrderRows,
  reconciliationColumns,
} from "../../../redux/actions/loans";

import Dropzone from "react-dropzone";
import { Loader } from "../../../UI/Loaders/Loaders";
import { appInsights } from "../../../config/appInsights";

export const Reconciliation = (props) => {
  const [isChecked, setIsChecked] = useState(false);
  const [files, setFiles] = useState("");
  const [reference, setReference] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState({});
  const [tableMetaData, setTableMetaData] = useState({});
  const [aggregatorId, setAggregatorId] = useState("");

  const uploadFile = () => {
    files.append("reference", reference);
    files.append("remark", "");
    files.append("aggregator_id", aggregatorId);

    setLoading(true);
    ajaxMethods
      .post(ajaxEndpoints.MASS_RECONCILIATION, files, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          const { disbursable_amt, id, reference, xaggregator_id } =
            response.data.data;
          const reOrderedTableData = reOrderRows(
            reconciliationColumns,
            response.data.data.reconcillation_reference
          );
          setTableData(reOrderedTableData);
          setTableMetaData({ disbursable_amt, id, reference, xaggregator_id });
          props.onSetToast("success", response.data.message);
          //clear input
          // setFiles("");
          setReference("");
          setAggregatorId("");
        } else {
          props.onSetToast("error", response.data.message);
          setTableData({});
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "Reconciliation.js",
          },
        });
        setLoading(false);
        // props.onSetToast('error', response.data.message);
      });
  };

  const getReconciliation = () => {
    setLoading(true);
    ajaxApi
      .get(`${ajaxEndpoints.GET_RECONCILIATION}?reference=${reference}`)
      .then((response) => {
        setLoading(false);
        if (response.data.status_code === 200) {
          const { disbursable_amt, id, reference, xaggregator_id } =
            response.data.data;
          const reOrderedTableData = reOrderRows(
            reconciliationColumns,
            response.data.data.reconcillation_reference
          );
          setTableData(reOrderedTableData);
          setTableMetaData({ disbursable_amt, id, reference, xaggregator_id });

          props.onSetToast("success", response.data.message);
          //clear input
          // setFiles("");
          setReference("");
          setAggregatorId("");
        } else {
          props.onSetToast("error", response.data.message);
          setTableData({});
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "Reconciliation.js",
          },
        });
        setLoading(false);

        if (error.response) {
          props.onSetToast("error", error.response.data.message);
        }

        setTableData({});

        if (error.response.status === 401) {
          window.location.replace("/logout");
        }
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.clearToast();
    if (files && reference) {
      uploadFile();
    } else if (reference && !files) {
      getReconciliation();
    }
  };

  const onDrop = (acceptedFiles) => {
    acceptedFiles.forEach((file, index) => {
      //We should keep this sir
      let formData = new FormData();
      formData.append("excel_file", file);

      setFiles(formData);
    });
  };

  if (loading) return <Loader text="Loading..." centered="true" />;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          className="card animated speed-1x fadeInRight"
          style={{ width: "auto" }}
        >
          <div className="body text-center">
            <h3 className="m-t-0">
              <i className="adv-icon fas fa-handshake" />
              &nbsp; Reconciliation
            </h3>
            <p className="settings-block text-muted">
              Upload reconciliation document or use reference to fetch
            </p>

            <form onSubmit={handleSubmit}>
              <label className="label-txt">Reference Code</label>
              <div className="form-group inputWithIcon">
                <input
                  type="text"
                  className="user__form form-control"
                  placeholder="Enter reference code"
                  autoComplete="off"
                  name="treshold_amount"
                  value={reference}
                  // data-form="investment"
                  // readOnly={(!investmentEdit)}
                  onChange={(e) => setReference(e.target.value)}
                  required
                />
                <i className="fas fa-sync" />
              </div>

              <label>
                <input
                  type="checkbox"
                  name="role"
                  value={isChecked}
                  onChange={(e) => {
                    setIsChecked(!isChecked);
                    setFiles("");
                  }}
                  className="has-value"
                />
                Upload reconciliation document
              </label>

              {isChecked && (
                <>
                  <label
                    htmlFor="aggregator"
                    className="label-txt"
                    style={{ marginTop: "15px" }}
                  >
                    {" "}
                    Select Aggregator{" "}
                  </label>
                  <select
                    onChange={(e) => setAggregatorId(e.target.value)}
                    id="aggregator"
                    className="table-fetch-select"
                    value={aggregatorId}
                  >
                    <option value="" selected disabled>
                      Please choose an aggregator
                    </option>
                    {props.allAggregators.aggregators &&
                      props.allAggregators.aggregators.map((option, i) => (
                        <option key={i} value={option.aggregator_id}>
                          {option.biz_name}
                        </option>
                      ))}
                  </select>

                  <label className="label-txt" style={{ marginTop: "15px" }}>
                    Upload File
                  </label>
                  <div>
                    <Dropzone
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv"
                      onDrop={onDrop}
                      // {...rest}
                      className="w-100 h7 dropzone-container"
                      activeClassName="bg-light-green"
                      rejectClassName="bg-light-red"
                      // disableClick={this.state.currLevel === ''}
                      name="formFiles"
                      style={{
                        textAlign: "center",
                        border: "1px dashed grey",
                        borderRadius: "5px",
                        padding: "20px",
                        width: "100px",
                      }}
                    >
                      {({
                        isDragActive,
                        isDragReject,
                        acceptedFiles,
                        rejectedFiles,
                      }) => {
                        return (
                          <Fragment>
                            {/* <Icon name="upload" size="huge"></Icon> */}
                            <h3>
                              {acceptedFiles.length || rejectedFiles.length
                                ? `Accepted ${acceptedFiles.length}, rejected ${rejectedFiles.length} file`
                                : "Upload reconciliation file here."}
                            </h3>
                            <h6 style={{ marginTop: "5px" }}>
                              {acceptedFiles.length
                                ? acceptedFiles[0].name
                                : "Drag and drop, or click to select"}
                            </h6>
                          </Fragment>
                        );
                      }}
                    </Dropzone>
                  </div>
                </>
              )}

              <div className="d-flex justify-content-center mt-3">
                <button
                  type="submit"
                  className="btn login-btn"
                  data-form="investment"
                  disabled={
                    loading || !reference || (isChecked && !aggregatorId)
                  }
                >
                  {loading && (
                    <span className="spinner-border spinner-border-sm ml-3"></span>
                  )}
                  <i className="fas fa-share" />
                  &nbsp; Send
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {!loading && Object.keys(tableData).length > 0 && (
        <div>
          {/*User & Financial Stats*/}
          <div className="row clearfix mt-30 grid__padding">
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="body text-center">
                  {/* <h3 className="m-t-0">&#8358;14,500,000</h3> */}
                  <h3 className="m-t-0">{tableMetaData.disbursable_amt}</h3>
                  <p className="text-muted">Disbursable Amount</p>
                  {/* <small>(Amount)</small> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="body text-center">
                  {/* <h3 className="m-t-0">{(count) ? count : 'unavailable'}</h3> */}
                  <h3 className="m-t-0">{tableMetaData.id}</h3>
                  <p className="text-muted">ID</p>
                  {/* <small>(Number)</small> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="body text-center">
                  {/* <h3 className="m-t-0">75,273</h3> */}
                  <h3 className="m-t-0">{tableMetaData.reference}</h3>
                  <p className="text-muted">Reference Code</p>
                  {/* <small>&nbsp;</small> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card">
                <div className="body text-center">
                  {/* <h3 className="m-t-0">3%</h3> */}
                  <h3 className="m-t-0">{tableMetaData.xaggregator_id}</h3>
                  <p className="text-muted">Aggregator ID</p>
                  {/* <small>&nbsp;</small> */}
                </div>
              </div>
            </div>
          </div>
          <div className="grid__padding animated speed-1x fadeInRight">
            <MDBDataTable
              responsive
              minimal="true"
              striped
              bordered
              hover
              data={tableData}
            />
          </div>
        </div>
      )}
    </div>
  );
};
